import { motion } from "framer-motion";

const stats = [
  { value: "07", label: "Disciplines" },
  { value: "01", label: "Standard — Excellence" },
];

export default function Manifesto() {
  return (
    <section id="about" className="relative py-28 lg:py-40" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 lg:gap-10 items-center">
        <div className="lg:col-span-7">
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-8"
            data-testid="manifesto-overline"
          >
            03 — The Veritas Standard
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#F5F5F5]"
            data-testid="manifesto-headline"
          >
            Unique custom designs.
            <br />
            <span className="italic text-[#D4AF37]">Talented professional service.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.2 }}
            className="mt-8 max-w-xl text-base font-light leading-relaxed tracking-wide text-[#A3A3A3]"
            data-testid="manifesto-body"
          >
            Unique custom designs. Talented professional service. Clear
            communication, careful planning, and quality craftsmanship
            throughout every phase — proudly serving Lee's Summit, Missouri,
            and surrounding communities.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.3 }}
            className="mt-12 grid grid-cols-2 gap-6 max-w-md"
            data-testid="manifesto-stats"
          >
            {stats.map((s) => (
              <div key={s.label} className="border-l border-[#D4AF37]/30 pl-4">
                <p className="font-display text-3xl sm:text-4xl text-[#D4AF37]">{s.value}</p>
                <p className="mt-2 text-[10px] tracking-[0.25em] uppercase text-[#A3A3A3]">{s.label}</p>
              </div>
            ))}
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.15 }}
          className="lg:col-span-5"
        >
          <div className="relative">
            <div className="absolute -inset-3 border border-[#D4AF37]/25 translate-x-4 translate-y-4" aria-hidden="true" />
            <div className="relative overflow-hidden bg-[#111111]">
              <img
                src="/images/flyer.jpg"
                alt="Veritas Development Group — quality renovations flyer"
                className="w-full h-auto object-cover"
                data-testid="manifesto-flyer-image"
              />
            </div>
          </div>
          <p className="mt-10 text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">
            Quality renovations. Exceptional results.
          </p>
        </motion.div>
      </div>

    </section>
  );
}
